'use strict';
(() => {
  const heroArt = document.querySelector('[data-jayden-rotation]');
  if (heroArt) {
    const frames = [...heroArt.querySelectorAll('[data-jayden-frame]')];
    const controls = [...heroArt.querySelectorAll('[data-jayden-skin-control]')];
    const name = heroArt.querySelector('[data-jayden-skin-name]');
    const status = heroArt.querySelector('[data-rotation-status]');
    let active = 0;
    let timer;
    let stopped = false;
    const show = (index) => {
      if (!frames[index] || !controls[index]) return;
      active = index;
      frames.forEach((frame, frameIndex) => { frame.hidden = frameIndex !== index; });
      controls.forEach((control, controlIndex) => {
        control.setAttribute('aria-pressed', String(controlIndex === index));
      });
      if (name) name.textContent = controls[index].dataset.name;
    };
    const stop = () => {
      if (stopped) return;
      stopped = true;
      clearInterval(timer);
      heroArt.dataset.rotationState = 'paused';
      if (status) status.textContent = 'MANUAL / SKIN SELECTED';
    };
    controls.forEach((control, index) => control.addEventListener('click', () => {
      stop();
      show(index);
    }));
    show(0);
    if (frames.length === controls.length && frames.length > 1) {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        heroArt.dataset.rotationState = 'paused';
        if (status) status.textContent = 'CHOOSE A SKIN';
      } else {
        timer = setInterval(() => show((active + 1) % frames.length), 4500);
        document.addEventListener('pointerdown', stop, { capture: true, once: true });
        document.addEventListener('keydown', stop, { capture: true, once: true });
      }
    }
  }
  const form = document.querySelector('#jayden-enquiry');
  if (!form) return;
  const packageInputs = [...form.querySelectorAll('input[name="package"], input[name="contact[Package]"]')];
  const addonInputs = [...form.querySelectorAll('[data-addon]')];
  const sparringFields = form.querySelector('[data-sparring-only]');
  const summaries = [...form.querySelectorAll('[data-selection-summary]')];
  const summaryPrice = form.querySelector('[data-selection-price]');
  const addonSummary = form.querySelector('[data-addon-summary]');
  const priceField = form.querySelector('[data-price-field]');
  const selectedPackage = () => packageInputs.find(input => input.checked);
  const sync = () => {
    const sparring = !!form.querySelector('[data-sparring-addon]:checked');
    if (sparringFields) {
      sparringFields.hidden = !sparring;
      sparringFields.querySelectorAll('input').forEach(input => {
        input.disabled = !sparring;
      });
    }
    const choice = selectedPackage();
    const price = choice?.dataset.price || '';
    const label = choice?.value === 'Please advise' ? 'Package recommendation' : `${choice?.value || 'Package recommendation'} camp`;
    summaries.forEach(item => { item.textContent = label; });
    if (summaryPrice) summaryPrice.textContent = price ? `${price} PER WEEK` : 'PRICE CONFIRMED AFTER REVIEW';
    if (priceField) priceField.value = price ? `${price} per week` : 'To be advised';
    const requested = addonInputs.filter(input => input.checked).map(input => input.dataset.addonLabel);
    if (addonSummary) addonSummary.textContent = requested.length ? `${requested.join(' + ')} requested · additional fee if confirmed` : 'No additional session requested.';
  };
  [...packageInputs, ...addonInputs].forEach(input => input.addEventListener('change', sync));
  document.querySelectorAll('[data-select-package]').forEach(link => link.addEventListener('click', () => {
    const input = packageInputs.find(item => item.value === link.dataset.selectPackage);
    if (input) {
      input.checked = true;
      sync();
    }
  }));
  sync();
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const button = form.querySelector('[data-jp-whatsapp-submit]');
    const number = (button.dataset.whatsappNumber || '').replace(/\D/g, '');
    if (!number) return;
    const data = new FormData(form);
    const get = name => data.get(`contact[${name}]`) || '';
    const details = [
      'JAYDEN PRICE DEVELOPMENT CAMP / APPLICATION',
      '',
      `Package: ${get('Package')}`,
      `Weekly price shown: ${get('Displayed weekly price')}`,
      `Technical session requested: ${get('Technical session requested') ? 'Yes' : 'No'}`,
      `Sparring session requested: ${get('Sparring session requested') ? 'Yes' : 'No'}`,
      `Name: ${get('name')}`,
      `Email: ${get('email')}`,
      `Phone: ${get('phone')}`,
      `Age: ${get('Age')}`,
      `Weight / class: ${get('Current weight or class')}`,
      `Gym: ${get('Gym')}`,
      `Bout experience: ${get('Bout experience')}`,
      `Current ability: ${get('Current ability')}`,
      `Titles won: ${get('Titles won')}`,
      `Preferred week: ${get('Preferred week')}`,
      ...(get('Sparring session requested') ? [`Coach / club contact: ${get('Coach or club contact')}`] : []),
      '',
      `Training objectives: ${get('body')}`
    ].join('\n');
    window.location.assign(`https://wa.me/${number}?text=${encodeURIComponent(details)}`);
  });
  if (!form.hasAttribute('data-preview')) return;
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const data = new FormData(form);
    const details = [
      'JAYDEN PRICE DEVELOPMENT CAMP / APPLICATION',
      '',
      `Package: ${data.get('package') || ''}`,
      `Weekly price shown: ${data.get('displayed_price') || ''}`,
      `Additional technical session requested: ${data.get('Technical session requested') ? 'Yes (£100 if confirmed)' : 'No'}`,
      `Additional sparring session requested: ${data.get('Sparring session requested') ? 'Yes (£100 if approved)' : 'No'}`,
      `Name: ${data.get('name') || ''}`,
      `Email: ${data.get('email') || ''}`,
      `Phone: ${data.get('phone') || ''}`,
      `Age: ${data.get('Age') || ''}`,
      `Weight / class: ${data.get('Current weight or class') || ''}`,
      `Gym: ${data.get('Gym') || ''}`,
      `Bout experience: ${data.get('Bout experience') || ''}`,
      `Current ability: ${data.get('Current ability') || ''}`,
      `Titles won: ${data.get('Titles won') || ''}`,
      `Preferred week: ${data.get('Preferred week') || ''}`,
      ...(data.get('Sparring session requested') ? [`Coach / club contact: ${data.get('Coach or club contact') || ''}`] : []),
      '',
      `Training objectives: ${data.get('body') || ''}`
    ].join('\n');
    const preview = form.querySelector('[data-enquiry-preview]');
    const email = form.querySelector('[data-enquiry-email]');
    email.href = `mailto:londonboxingandfitnessstore@gmail.com?subject=${encodeURIComponent('Jayden Price Development Camp application')}&body=${encodeURIComponent(details)}`;
    preview.hidden = false;
    preview.dataset.details = details;
    preview.scrollIntoView({ block: 'nearest', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  form.querySelector('[data-copy-enquiry]')?.addEventListener('click', async () => {
    const status = form.querySelector('[data-copy-status]');
    try {
      await navigator.clipboard.writeText(form.querySelector('[data-enquiry-preview]').dataset.details || '');
      status.textContent = 'Enquiry details copied.';
    } catch {
      status.textContent = 'Copy is unavailable here. Please use Open Email App.';
    }
  });
})();
